import { ComponentErrorBoundary } from "shared/components/atoms/ComponentErrorBoundary";
import { formatBrazilianCurrency } from "shared/utils/formatBrazilianCurrency";
import { useGlobalContext } from "shared/utils/hooks/useGlobalContext";

import useCheckoutStepsOffersContext from "@CheckoutStepsOffers/provider";
import InformationCircleSVG from "@payment/assets/InformationCircleSVG";

import DiscountInformation from "../../DiscountInformation";
import {
  ContainerProductPriceOverviewCreditCard,
  ContentMainProduct,
  ContentSpecialOffers,
  Discount,
  LittleLetters,
  Paragraph,
  ProductTitle,
  Row,
  WrapperInformation,
} from "./styles";

const FinalPricesCreditCard = () => {
  const {
    steps,
    offer,
    coupon,
    installments,
    installmentOptions,
    installmentSelected,
    orderBumpsSelected,
    orderBumpsInstallmentSelected,
  } = useCheckoutStepsOffersContext();

  const { state } = useGlobalContext();

  const acquirer = state?.tenancy?.acquirer;

  const IS_MIN_VALUE =
    acquirer?.complement_min_value &&
    installments[0]?.value < acquirer?.min_value;
  const HAS_VALUE_TO_PAY = installments[0]?.value > 0;

  const [installmentToRender] = installmentOptions?.filter(
    (option) => option?.value === installmentSelected?.installment?.toString(),
  );

  return (
    <ContainerProductPriceOverviewCreditCard>
      <ContentMainProduct>
        {!!coupon && (
          <>
            <Row>
              <Paragraph>Preço original</Paragraph>
              <Paragraph>
                {formatBrazilianCurrency(Number(offer?.offer?.price))}
              </Paragraph>
            </Row>
            <Row>
              <Paragraph>Desconto</Paragraph>
              <Discount>
                - {formatBrazilianCurrency(coupon?.item?.coupon_discount_value)}
              </Discount>
            </Row>
          </>
        )}
        {IS_MIN_VALUE && HAS_VALUE_TO_PAY && (
          <>
            <Row>
              <Paragraph>Taxa de processamento</Paragraph>

              <Paragraph>
                {formatBrazilianCurrency(
                  acquirer?.min_value - installments[0]?.value,
                )}
              </Paragraph>
            </Row>

            <Row>
              <LittleLetters>
                <InformationCircleSVG /> Taxa de processamento: Tarifa para
                processar a transação e garantir que o pagamento seja efetuado
                com segurança.
              </LittleLetters>
            </Row>
          </>
        )}

        {IS_MIN_VALUE && HAS_VALUE_TO_PAY ? (
          <>
            <Row>
              <Paragraph>{offer?.group?.title}</Paragraph>
              <Paragraph>
                {formatBrazilianCurrency(acquirer?.min_value)}
              </Paragraph>
            </Row>
          </>
        ) : (
          <>
            <Row>
              <Paragraph>{offer?.group?.title}</Paragraph>
              <Paragraph>
                {!!coupon && installments[0]?.value === 0
                  ? formatBrazilianCurrency(installments[0]?.value)
                  : installmentToRender?.text}
              </Paragraph>
            </Row>
          </>
        )}
      </ContentMainProduct>
      <ComponentErrorBoundary>
        <DiscountInformation />
      </ComponentErrorBoundary>
      <ContentSpecialOffers>
        <ProductTitle>Ofertas especiais</ProductTitle>
        {orderBumpsSelected?.map((orderBump) => (
          <ComponentErrorBoundary key={orderBump?.id}>
            <Row key={orderBump?.id}>
              <Paragraph>{orderBump?.group?.title}</Paragraph>
              <Paragraph>
                {orderBumpsInstallmentSelected[
                  orderBump?.slug
                ]?.option?.text?.replace(" sem juros", "")}
              </Paragraph>
            </Row>
          </ComponentErrorBoundary>
        ))}
      </ContentSpecialOffers>
      <WrapperInformation>
        <span>
          Cada cobrança será feita separadamente no cartão cadastrado.
        </span>
      </WrapperInformation>
    </ContainerProductPriceOverviewCreditCard>
  );
};

export default FinalPricesCreditCard;
